import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const PageNotFound = () => {
  const [t] = useTranslation();
  const history = useNavigate();

  return (
    <div className="page-not-found">
      <h1>404</h1>
      <p>{t('pageNotFound')}</p>

      <button onClick={() => history('/')}>Home</button>
    </div>
  );
};

export default PageNotFound;
